import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "transferCard__footer" }
const _hoisted_2 = { class: "infoPrice" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Итого: ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "*Без НДС", -1)
const _hoisted_6 = {
  key: 0,
  href: "#",
  class: "infoBtn"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("b", null, _toDisplayString(_ctx.item.Price) + " ₽ ", 1),
      _hoisted_4,
      _hoisted_5
    ]),
    (_ctx.hasControl)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (!_ctx.isModeOffer)
            ? (_openBlock(), _createBlock("a", _hoisted_6, "Подробнее"))
            : _createCommentVNode("", true),
          (_ctx.isModeOffer && !_ctx.hasCansel)
            ? (_openBlock(), _createBlock("span", {
                key: 1,
                class: "infoBtn",
                onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.selectData(...args)), ["prevent"]))
              }, " Выбрать "))
            : _createCommentVNode("", true),
          (_ctx.isModeOffer && _ctx.hasCansel)
            ? (_openBlock(), _createBlock("span", {
                key: 2,
                class: "infoBtn",
                onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.unselect()), ["prevent"]))
              }, " Отмена "))
            : _createCommentVNode("", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("", true)
  ]))
}